import { employeesExport } from 'services/employeesApi'
import { downloadCSV } from 'utils/downloadCSV'
import { jsonToCsv } from './JsonToCsvConverter'
import { generateCompleteFileName } from './fileNameGenerator'

export const onEmployeesCSVExport = async (
  employeesIndices: string,
  entityId: string,
  vertical: string,
  tin?: string,
  onlineName?: string,
): Promise<void> => {
  try {
    const { employees, headers } = await employeesExport(employeesIndices, entityId, vertical)
    const employeesCSV = jsonToCsv(employees, headers)
    
    const fileName = generateCompleteFileName({
      vertical: vertical,
      exportType: 'specific-activity',
      specificActivityType: 'Employees',
      tin: tin,
      onlineName: onlineName,
      entityId: entityId
    })
    const finalFileName = `${fileName}.csv`
    
    downloadCSV(employeesCSV, finalFileName)
  } catch (error) {
    console.error('Error exporting CSV:', error)
    throw error
  }
}
